<div>
  <!-- <nz-select class="quest-input-width d-b" nzPlaceHolder="Choose" (ngModelChange)="findViewByviewType($event)"
    [(ngModel)]="selectViewType">
    <nz-option nzCustomContent *ngFor="let item of viewType" [nzLabel]="item?.value" [nzValue]="item?.key">
      {{item?.value|| '' | translate}}</nz-option>
  </nz-select>
  <br> -->

  <nz-timeline>
    <nz-timeline-item [nzColor]="item.color" *ngFor="let item of workFlowAudit">
      <h4 class="f-w-600">{{(item.serviceTask | technicalTranslate) || '' }} <nz-tag class="m-l-5"
          [nzColor]="item.color">
          {{(item.status | technicalTranslate) || ''}}</nz-tag>
      </h4>
      <p>
        <!-- <i class="anticon anticon-calendar"></i> -->
        <span nz-icon nzType="calendar" nzTheme="outline"></span>
        {{item?.startDt | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}
        <!-- <span *ngIf="item.startDt && item.endDt"> ( {{getDayDifference(item.startDt,item.endDt)}})</span> -->
        <span *ngIf="item.startDt && !item.endDt">(<span translate> {{'Task In Progress' | MMSTranslate}} </span>)</span>
      </p>
      <div class="timeline-card">
        <p>
          <span id="workQueueField" *ngIf="item.type== 'workflow' && selectViewType != 'Correspondence' "> <span translate> {{'Work Queue' | MMSTranslate}}:
            </span> {{(item?.workQueue | technicalTranslate : workQueueCd ) || '-'}}
          </span> <br>
          <!-- <span id="policyField" *ngIf="item.type== 'workflow' && selectViewType != 'Correspondence' "><span translate> {{'Assessor' | MMSTranslate}}:
            </span> {{(item?.taskUser | technicalTranslate ) || ''}}
          </span><br> -->
          <!-- <span *ngIf="item.type== 'workflow' && selectViewType != 'Correspondence' "> <span translate> Priority:</span> {{item.priority || '' | translate}} </span>
        <br> -->
          <span id="assigneeId" *ngIf="item.type== 'workflow' && selectViewType != 'Correspondence' "><span translate> {{'Assignee' | MMSTranslate}}:</span>
            {{(item?.taskUser | technicalTranslate ) || '-'}}
          </span><br>
          <!-- <span *ngIf="item.type== 'workflow' && selectViewType != 'Correspondence' "> <span translate> Priority:</span> {{item?.priority || '' | translate}} </span>
        <br> -->
          <span id="startDate" *ngIf="item.type== 'workflow' && selectViewType != 'Correspondence' && item.startDt"> <span translate> {{'Start Date and Time' | MMSTranslate}}:</span>
            {{(item?.startDt | date:'dd-MM-yy HH:mm:ss') || '-'}} </span>
          <br>
          <span *ngIf="item.type== 'workflow' && selectViewType != 'Correspondence' && item.endDt"> <span translate> {{'End Date and Time' | MMSTranslate}}:</span>
            {{(item?.endDt | date:'dd-MM-yy HH:mm:ss') || '-'}} </span>
          <br *ngIf="item.endDt">
          <span *ngIf="item.type== 'workflow' && selectViewType != 'Correspondence' ">
            <span *ngIf="item.startDt !=null && item.endDt !=null"><span translate> {{'Completed in (TAT)' | MMSTranslate}}:</span>
              <!-- {{(item?.tatInMins? (item?.tatInMins) : '-') || '-'}} Minutes -->
              {{getDayDifference(item?.startDt,item?.endDt)}}
            </span></span>
          <br *ngIf="item.startDt !=null && item.endDt !=null">

          <span *ngIf="item.type== 'workflow' && selectViewType != 'Correspondence' ">
            <span *ngIf="item.lastReassignedBy"><span translate> {{'Assigned By' | MMSTranslate}}:</span>
              {{item?.lastReassignedBy}}</span></span>
          <br *ngIf="item.lastReassignedBy">

          <span *ngIf="item.type== 'workflow' && selectViewType != 'Correspondence' && item.remarksBy && item.remarksFor "><span translate> {{'Remarks' | MMSTranslate}} </span>
            <a (click)="viewRemarks(item?.remarksBy,item?.remarksFor)"><i nz-icon nzType="file-text"
                nzTheme="outline"></i>
              View</a>
          </span>

          <!-- <span *ngIf="item.type== 'workflow' && selectViewType != 'Correspondence' "> <span translate> Remarks By:</span>
          <a *ngIf="item.remarksBy" (click)="viewRemarks(item?.remarksBy)">View</a>
          <span *ngIf="!item.remarksBy">-</span>
        </span>
        <br>
        <span *ngIf="item.type== 'workflow' && selectViewType != 'Correspondence' "> <span translate> Remarks
            For:</span> 
          <a *ngIf="item.remarksFor" (click)="viewRemarks(item?.remarksFor)">View</a>
          <span *ngIf="!item.remarksFor">-</span>
          </span> -->
        </p>
      </div>
    </nz-timeline-item>
  </nz-timeline>

  <nz-modal nzTitle="Remarks" [(nzVisible)]="remarksModal" (nzOnCancel)="remarksModal=false"
    (nzOnOk)="remarksModal=false" nzWidth="75%" [nzFooter]="modalFooter">
    <ng-container *nzModalContent>
      <div *ngIf="remarksModal">
        <h5 class="heading">{{'Remarks by' | MMSTranslate}}:</h5>
        <p>{{remarksByData ? remarksByData:"--"}}</p>
        <h5 class="heading">{{'Remarks for' | MMSTranslate}}:</h5>
        <p>{{remarksForData ? remarksForData : "--" }}</p>
      </div>
    </ng-container>
    <ng-template #modalFooter>
      <button nz-button nzType="default" (click)="cancelRemarks()">{{'Ok' | MMSTranslate}}</button>
    </ng-template>
  </nz-modal>
</div>
<app-generic-zero-ui [list]="workFlowAudit" icon="file-search" title=""
  message="Activity timeline will be generated, once you save the transaction"></app-generic-zero-ui>